import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { ChristmasContactBar } from '../christmas/ChristmasContactBar';
import { homeHeaderContact } from '../../data/christmasContacts';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { ServicesDropdown } from './ServicesDropdown';
import { navItems } from '../../data/navigation';
import { business } from '../../data/business';
const linkClass = 'block whitespace-nowrap rounded-full px-2.5 py-2 text-[13px] font-bold uppercase tracking-[0.08em] text-forest/80 transition-colors lg:px-4 lg:text-[14px] hover:bg-olive-50 hover:text-olive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage';
const quoteClass = 'inline-flex items-center justify-center whitespace-nowrap rounded-full bg-olive font-bold uppercase tracking-[0.08em] text-white transition-colors hover:bg-olive-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2';
export function Header() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const isChristmasPage = pathname.startsWith('/christmas-lights');
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  const closeMenu = () => {
    setOpen(false);
    setServicesOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full border-b border-forest/10 bg-white" data-id="element-354" data-mp="1wltr7olohbo">
      <div aria-hidden="true" className="h-1 w-full bg-olive" data-id="element-355" data-mp="1u93864s0yn0" />
      {isChristmasPage ? <ChristmasContactBar data-id="element-356" data-mp="19c8g7t7uusys" /> : <ChristmasContactBar contacts={[homeHeaderContact]} ariaLabel="Free quote contact" data-id="element-357" data-mp="1daze42k5aemy" />}
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8 lg:gap-8" data-id="element-358" data-mp="3ablqoxca9ml9">
        <Logo data-id="element-359" data-mp="35c8sxhjviv3w" />

        <nav aria-label="Primary" className="hidden flex-1 justify-center md:flex" data-id="element-360" data-mp="35cs9ouxsfdgc">
          <ul className="flex items-center gap-0.5 lg:gap-2" data-id="element-361" data-mp="3jc09nq1rypll">
            {navItems.map(item => <li key={item.label} data-id="element-362" data-mp="3ef9ynh4tuk71">
                {item.children ? <ServicesDropdown item={item} data-id="element-363" data-mp="2qnw5j8yuqkl0" /> : <Link to={item.href} className={linkClass} data-id="element-364" data-mp="2mmspomgt0ojs">
                    {item.label}
                  </Link>}
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-365" data-mp="30g1sg4a8ybtc">
          <Link to={business.quoteHref} className={`${quoteClass} h-10 px-4 text-[12px] sm:h-11 sm:px-6 sm:text-[13px]`} data-id="element-366" data-mp="2vmp7q58oup5v">
            Get Your Quote
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-10 w-10 items-center justify-center rounded-full bg-olive-50 text-forest transition-colors hover:bg-olive-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage md:hidden" data-id="element-367" data-mp="22z32ksjtbcgw">
            {open ? <XIcon className="h-5 w-5" data-id="element-368" data-mp="ed31uug2853o" /> : <MenuIcon className="h-5 w-5" data-id="element-369" data-mp="1251fvm6w8eki" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-370" data-mp="166d4pphy0vrn">
        {open && <motion.nav id="mobile-menu" aria-label="Mobile" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="overflow-hidden border-t border-forest/10 bg-white md:hidden" data-id="element-371" data-mp="16524u0rmc85t">
            <ul className="flex flex-col gap-1 px-5 py-4 sm:px-8" data-id="element-372" data-mp="3hwxm6zitmu9r">
              {navItems.map(item => <li key={item.label} data-id="element-373" data-mp="10yi6uzinpal">
                  {item.children ? <>
                      <button type="button" onClick={() => setServicesOpen(v => !v)} aria-expanded={servicesOpen} aria-controls="mobile-services" className="flex w-full items-center justify-between rounded-xl px-3 py-3 text-left text-base font-semibold text-forest transition-colors hover:bg-olive-50 hover:text-olive" data-id="element-374" data-mp="3se17zy5gkxv6">
                        {item.label}
                        <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ${servicesOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-375" data-mp="awrpnzydosli" />
                      </button>
                      {servicesOpen && <div id="mobile-services" className="ml-3 border-l-2 border-sage/50 pl-3" data-id="element-376" data-mp="2qnw4adjtxupr">
                          {item.children.length > 0 ? <ul data-id="element-377" data-mp="2lk3qr2014gvh">
                              {item.children.map(child => <li key={child.href} data-id="element-378" data-mp="2qj6khqak70o5">
                                  <Link to={child.href} onClick={closeMenu} className="block rounded-lg px-3 py-2.5 text-[15px] text-forest/80 hover:bg-olive-50 hover:text-olive" data-id="element-379" data-mp="2qieviybgw16u">
                                    {child.label}
                                  </Link>
                                </li>)}
                            </ul> : <p className="px-3 py-2.5 text-sm text-forest/50" data-id="element-380" data-mp="1ewpz106kmfgw">Services coming soon.</p>}
                        </div>}
                    </> : <Link to={item.href} onClick={closeMenu} className="block rounded-xl px-3 py-3 text-base font-semibold text-forest transition-colors hover:bg-olive-50 hover:text-olive" data-id="element-381" data-mp="1bvd6doo2jitx">
                      {item.label}
                    </Link>}
                </li>)}
            </ul>
            <div className="border-t border-forest/10 px-5 py-4 sm:px-8" data-id="element-382" data-mp="1urv5ir58yl07">
              <Link to={business.quoteHref} onClick={closeMenu} className={`${quoteClass} h-12 w-full text-[13px]`} data-id="element-383" data-mp="1ptbi0mb0915q">
                Get Your Quote
              </Link>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}